import {Component, Injector} from '@angular/core';
import {BaseComponent} from '../../base.component';

@Component({
  selector: 'app-payment-status',
  standalone: false,
  templateUrl: './payment-status.component.html',
  styleUrl: './payment-status.component.scss'
})
export class PaymentStatusComponent extends BaseComponent {
  result?: any;
  traceCode?: any;
  amount?: any;

  constructor(injector: Injector) {
    super(injector);
    this.activatedRoute.queryParamMap.subscribe(params => {
      this.result = params.get('result');
      this.traceCode = params.get('traceCode');
      this.amount = params.get('amount');
    });
  }
}
